import type { MovimientoCaja } from "../types/caja.types";
import { isMotivoRetiroTopeEfectivo } from "../constants/cajaMovimientoMotivos";

/** Movimientos activos (no anulados). */
function activos(movimientos: MovimientoCaja[]) {
  return movimientos.filter((m) => m.estado !== "anulado");
}

/**
 * Desagrega egresos que afectan el efectivo esperado en caja para el ticket de cierre.
 * Los retiros por tope de seguridad no son “gastos”: sacan efectivo para guardarlo / bajar gaveta.
 */
export function splitEgresosCajaFisica(movimientos: MovimientoCaja[]) {
  const m = activos(movimientos);
  const retirosTop = m
    .filter((x) => x.tipo === "retiro" && isMotivoRetiroTopeEfectivo(x.motivo))
    .reduce((s, x) => s + x.monto, 0);
  const retirosOtros = m
    .filter((x) => x.tipo === "retiro" && !isMotivoRetiroTopeEfectivo(x.motivo))
    .reduce((s, x) => s + x.monto, 0);
  const gastos = m
    .filter((x) => x.tipo === "gasto")
    .reduce((s, x) => s + x.monto, 0);
  return {
    retirosTop,
    retirosOtros,
    gastos,
    totalRetirosYGastos: retirosTop + retirosOtros + gastos,
  };
}
